/* eslint-disable no-underscore-dangle */
import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { Props } from '../../../types';
import { PageHeader } from './components/header';
import { WideImage } from './components/wide-image';
import { Content } from './components/content';
import { DownloadSection } from './components/download-section';
import { ContactSection } from './components/contact-section';
import { FurtherContent } from './components/further-content';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const ModernLayout = ({ blok, getComponent }: PageProps) => (
  <>
    <PageHeader blok={blok} getComponent={getComponent} />
    <WideImage blok={blok} getComponent={getComponent} />
    <Content blok={blok} getComponent={getComponent} />
    <DownloadSection blok={blok} getComponent={getComponent} />
    <ContactSection blok={blok} getComponent={getComponent} />
    <FurtherContent blok={blok} getComponent={getComponent} />
  </>
);
